exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".about-fullscreen-container {\n  width: 100%;\n  background-size: cover;\n  background-position: center top; }\n  .about-fullscreen-container .about-fullscreen-content {\n    position: relative;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    width: 100%;\n    color: #ffffff !important;\n    background-color: rgba(0, 0, 0, 0.75);\n    font-size: 25px;\n    text-align: center;\n    padding-top: 150px; }\n  @media (max-width: 767px) {\n      .about-fullscreen-container .about-fullscreen-content {\n        font-size: 15px; } }\n  .about-fullscreen-container .about-fullscreen-content .header {\n      color: #ffffff !important; }\n  .about-us-content, .map-content {\n  font-size: 20px; }\n  .projects-container {\n  padding: 100px 0;\n  background: #fafafa; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/luvi/frontend/src/app/components/public/about/about.component.scss
// module id = ../../../../../src/app/components/public/about/about.component.scss
// module chunks = main